import React, { ReactNode } from "react";
import { Box, Typography } from "@mui/material";

import { Para14Text } from "components/shared/Typography";
import { PlatformType } from "types/design";

import { KitsDropdown } from "./KitsDropdown";

interface IPlatformSettingProps {
  platformType: PlatformType;
}

const DIRECTIVE_TEXTS: Record<PlatformType, ReactNode> = {
  [PlatformType.ILLUMINA]: (
    <>
      Select kits to be displayed on all VariantPlex<sup>®</sup>, FusionPlex
      <sup>®</sup>, and LiquidPlex&#8482; panels
    </>
  ),
  [PlatformType.IONTORRENT]: (
    <>
      Select kits to be displayed on all FusionPlex<sup>®</sup> panels
    </>
  ),
};

export const PlatformSetting: React.FC<IPlatformSettingProps> = ({
  platformType,
}) => {
  return (
    <Box>
      <Typography variant="h4" component="h3" paragraph>
        {platformType === PlatformType.ILLUMINA ? "Illumina" : "Ion Torrent"}
      </Typography>
      <Box
        ml={3}
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        gap="8px"
      >
        <Para14Text>{DIRECTIVE_TEXTS[platformType]}</Para14Text>
        <KitsDropdown platformType={platformType} />
      </Box>
    </Box>
  );
};
